<template>
    <div id="worksends-app" class="site-main tw-flex tw-justify-start tw-bg-gray-100" :class="hasBarClass">
        <template v-if="!$route.meta.public">
            <span v-if="sidebarDisplayed" id="ws-sidebar-burger" v-b-toggle.worksends-left-sidebar-toggle></span>
            <b-sidebar v-if="sidebarDisplayed" no-header backdrop width="300px" id="worksends-left-sidebar-toggle">
                <nav-sidebar id="worksends-left-sidebar" v-bind="{ menuLinks, bottomMenuLinks, suite }"/>
            </b-sidebar>
            <nav-sidebar v-if="!sidebarDisplayed" id="worksends-left-sidebar" :data-mode="sidebarMode" v-bind="{ menuLinks, bottomMenuLinks, suite }"/>
        </template>
        <main id="worksends-main" class="site-main">
            <div :id="`worksends-page-${ pageClass }`" class="worksends-page">
                <div id="worksends-page-content">
                    <router-view v-if="coreLoaded"/>
                </div>
            </div>
            <help-sidebar id="worksends-right-sidebar" :help-content="helpContent"/>
        </main><!-- #main -->
        <team-switcher-modal v-if="$store.state.modals.teamSwitcher"/>
        <contact-modal v-if="$store.state.modals.contactModal"/>
        <registration-modal v-if="$store.state.modals.registrationModal"/>
    </div>
</template>

<script>
export default {
    props: {
        menuLinks: {
            type: Object,
            required: true,
        },
        bottomMenuLinks: {
            type: Object,
            required: true,
        },
        suite: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            helpContent: '',
            sidebarDisplayed: false,
        };
    },
    computed: {
        pageClass() {
            const routeMeta = this.$route.matched.reduce((meta, route) => ({...route.meta, ...meta}), this.$route.meta);
            return routeMeta.pageClass || this.$route.name;
        },
        selectedSuite() {
            return this.apps.find(({name}) => this.suite === name);
        },
        sidebarMode() {
            return this.$store.state.sidebarMode;
        },
        hasBarClass() {
            if (this.$store.state.demo.isDemo || (this.$store.state.team && ['free','trial'].includes(this.$store.state.team.detail.plan))) return 'has-bar';
            else return '';
        },
		coreLoaded() {
			return this.$store.state.coreLoaded;
		},
    },
    async created() {
        try {
            const requests = [];
            this.$wait.start('app-loading');
            if (!this.$store.state.teamId) {
                await this.dispatchWaitAndNotify('fetchUserTeams', null, false, true);
            } else {
                requests.push(this.dispatchWaitAndNotify('fetchUserTeams', null, false, true));
            }
            if (this.$store.state.teamId) {
                requests.push(this.dispatchWaitAndNotify('fetchTeam', null, false, true));
                requests.push(this.dispatchWaitAndNotify('fetchCurrentUser', null, false, true));
                requests.push(this.dispatchWaitAndNotify('fetchGiftBoxCampaignsMenu', null, false, true));
            }
            await Promise.all(requests);
			console.log('user_loaded');
			
            if (!this.$store.state.demo.isDemo && this.$store.state.currentUser.user_id == this.$store.state.demo.userId) {
                // unauthorised access to pro with demo user
                localStorage.removeItem('wp_token');
                localStorage.removeItem('api_token');
                localStorage.removeItem('selectedTeam');
                window.location.replace(`${window.location.protocol}//${window.location.host}/pro/login`);
            }
            
            this.$store.commit('setCoreLoaded', true);
        } finally {
            this.$wait.end('app-loading');
        }
    },
    beforeRouteEnter(to, from, next) {
        if (!localStorage.getItem('api_token') || !localStorage.getItem('wp_token')) {
            return next('/login');
        }
        return next();
    },
    methods: {
        switchToApp(app) {
            this.selectedApp = app;
            this.$router.push(app.link)
        }
    },
};
</script>
